import { request } from './apiClient';
import { getSessionClientId } from './authSession';

const onlyDigits = (value) => value ? String(value).replace(/\D/g, '') : null;

// Monta o payload de empresa (camelCase) resolvendo o cliente da sessão e os contatos por função.
// AJUSTE BACKEND AQUI: mapeamento do formulario para o contrato da API de empresa.
export const buildEmpresaPayload = (formData, effectiveClientId) => ({
  razaoSocial: formData.razaoSocial.trim(),
  numrCnpj: onlyDigits(formData.numrCnpj),
  numrCpf: onlyDigits(formData.numrCpf),
  endereco: formData.endereco.trim(),
  codgCep: onlyDigits(formData.codgCep) ? Number(onlyDigits(formData.codgCep)) : null,
  idCidade: formData.idCidade ? Number(formData.idCidade) : null,
  idContatoTecnico: formData.idUsuarioTecnico || null,
  idContatoFinanceiro: formData.idUsuarioFinanceiro || null,
  idContatoAdministrativo: formData.idUsuarioAdministrativo || null,
  // AJUSTE BACKEND AQUI: usuários assinantes do rodapé dos relatórios.
  idUsuarioAssinatura1: formData.idUsuarioAssinatura1 ? Number(formData.idUsuarioAssinatura1) : null,
  idUsuarioAssinatura2: formData.idUsuarioAssinatura2 ? Number(formData.idUsuarioAssinatura2) : null,
  idCliente: effectiveClientId || getSessionClientId() || null,
});

// Lista todas as empresas.
export const getEmpresa = async (idCliente) => {
  // AJUSTE BACKEND AQUI: endpoint de listagem de empresas.
  const effectiveClientId = idCliente || getSessionClientId();
  return await request(`/api/empresa?idCliente=${effectiveClientId}`);
};

// Cria uma empresa; retorna { response, payload }.
export const createEmpresa = async (formData, effectiveClientId) => {
  const payload = buildEmpresaPayload(formData, effectiveClientId);

  // AJUSTE BACKEND AQUI: endpoint de criacao de empresa.
  const response = await request('/api/empresa', {
    method: 'POST',
    body: JSON.stringify(payload)
  });

  return { response, payload };
};

// Atualiza a empresa por id; retorna { response, payload }.
export const updateEmpresa = async (id, formData, effectiveClientId) => {
  const payload = buildEmpresaPayload(formData, effectiveClientId);
  payload.idEmpresa = Number(id);

  // AJUSTE BACKEND AQUI: update por id da empresa.
  const response = await request(`/api/empresa/${id}`, {
    method: 'PUT',
    body: JSON.stringify(payload)
  });

  return { response, payload };
};

// Exclui a empresa por id.
export const deleteEmpresa = async (id) => {
  // AJUSTE BACKEND AQUI: exclusao por id da empresa.
  return await request(`/api/empresa/${id}`, {
    method: 'DELETE'
  });
};